<template>
  <div class="makeOutInvoice">
    <el-dialog
      title="录入开票信息"
      :visible.sync="dialogVisible"
      :width="screenWidth>769?'30%':'80%'"
      :before-close="cancel"
    >
      <el-radio v-model="radio" label="1">个人</el-radio>
      <el-radio v-model="radio" label="2">企业</el-radio>
      <el-form v-if="!company">
        <el-form-item label="发票类型：">
          <label>电子普通发票</label>
        </el-form-item>
        <el-form-item label="发票内容：">
          <label>商品明细</label>
        </el-form-item>
      </el-form>
      <el-form
        :model="formInvoice"
        :rules="rules"
        ref="formInvoice"
        v-if="company"
        label-width="122px"
      >
        <el-form-item label="发票类型：">
          <label>电子普通发票</label>
        </el-form-item>
        <el-form-item label="发票内容：">
          <label>商品明细</label>
        </el-form-item>
        <el-form-item label="单位名称：" prop="custname">
          <el-input v-model="formInvoice.custname" auftocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号：" prop="custTaxNo">
          <el-input v-model="formInvoice.custTaxNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="注册地址：">
          <el-input v-model="formInvoice.custAddr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="注册电话：">
          <el-input v-model="formInvoice.custPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开户银行：">
          <el-input v-model="formInvoice.custBank" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="银行账号：">
          <el-input v-model="formInvoice.custAccount" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            type="textarea"
            v-model="formInvoice.invoMemo"
            placeholder="最多输入200个字"
            maxlength="200"
            @input="descInput"
          ></el-input>
          <!-- maxlength="200" -->
          <p style="margin-top:5px">{{remnant}}/200</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('formInvoice')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { UpdateInvoiceInfo, GetUserInvoiceInfo } from "@/api/admin/common.js";
// import { isMobile } from "@/util/validate.js";
import { mapGetters } from "vuex";
export default {
  props: ["dialogVisible"],
  computed: {
    ...mapGetters(["screenWidth"])
  },
  data() {
    // var checkTel = (rule, value, callback) => {
    //   if (!value) {
    //     callback();
    //   } else {
    //     if (isMobile(value)) {
    //       callback();
    //     } else {
    //       return callback(new Error("请输入正确的电话"));
    //     }
    //   }
    // };
    return {
      radio: "1",
      formInvoice: {},
      company: false,
      custtype: {},
      remnant: 200,
      rules: {
        custname: [
          { required: true, message: "请输入单位名称", trigger: "blur" }
        ],
        custTaxNo: [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" }
        ]
        // custPhone: [
        //   {
        //     trigger: "blur",
        //     validator: checkTel
        //   }
        // ]
      }
    };
  },
  watch: {
    radio(val) {
      if (val == 2) {
        this.company = true;
      } else {
        this.company = false;
      }
    }
  },
  created() {
    this.defaultData();
  },
  methods: {
    // 取出默认数据
    defaultData() {
      GetUserInvoiceInfo({}).then(data => {
        var list = data.data.result;
        if (list.invoiceInfo) {
          if (list.invoiceInfo.custtype == "01") {
            this.radio = "2";
            this.formInvoice = list.invoiceInfo;
            if (this.formInvoice.invoMemo) {
              this.remnant = 200 - this.formInvoice.invoMemo.length;
            } else {
              this.remnant = 200;
            }
          } else {
            this.radio = "1";
          }
        }
      });
    },
    // 取消
    cancel() {
      this.$emit("cancel", false);
      this.defaultData();
    },
    // 提交
    submitForm(formInvoice) {
      if (this.radio == 1) {
        this.$emit("cancel", false);
        this.custtype.custtype = "03";
        UpdateInvoiceInfo(Object.assign(this.custtype)).then(data => {
          var list = data.data.result;
          if (list.isSuccess) {
            this.$message({
              message: "发票信息录入成功",
              type: "success"
            });
            this.formInvoice = {};
            this.$emit("default");
          } else {
            this.$message.error("发票信息录入失败");
          }
        });
      } else {
        this.$refs[formInvoice].validate(valid => {
          if (valid) {
            this.custtype.custtype = "01";
            if (this.formInvoice.invoMemo) {
              if (this.formInvoice.invoMemo.length > 200) {
                this.$message({
                  message: "发票备注请控制在200字以内",
                  type: "warning"
                });
              } else {
                this.getContent();
              }
            } else {
              this.getContent();
            }
          }
        });
      }
    },
    // 限制文字字数
    descInput() {
      var txtVal = this.formInvoice.invoMemo.length;
      this.remnant = 200 - txtVal;
      if (this.remnant < 0) {
        this.remnant = 0;
      }
    },
    getContent() {
      this.$emit("cancel", false);
      UpdateInvoiceInfo(Object.assign(this.custtype, this.formInvoice)).then(
        data => {
          var list = data.data.result;
          if (list.isSuccess) {
            this.$message({
              message: "发票信息录入成功",
              type: "success"
            });
            this.$emit("default");
          } else {
            this.$message.error("发票信息录入失败");
          }
        }
      );
    }
  }
};
</script>

<style lang="less">
.makeOutInvoice {
  .el-dialog__body {
    padding: 8px 20px 0 20px;
    .el-form {
      margin-top: 10px;
      .el-form-item:first-child {
        margin-bottom: 5px;
        .el-form-item__label {
          line-height: 28px;
        }
        .el-form-item__content {
          line-height: 28px;
        }
      }
      .el-form-item:nth-child(2) {
        margin-bottom: 10px;
        .el-form-item__label {
          line-height: 28px;
        }
        .el-form-item__content {
          line-height: 28px;
        }
      }
      .el-form-item:last-child {
        .el-textarea__inner {
          min-height: 120px !important;
          font-family: "微软雅黑";
        }
      }
    }
  }
}
</style>
